import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/love', label: '恋爱漫画' },
    { to: '/category/action', label: '热血动作' },
    { to: '/category/fantasy', label: '奇幻冒险' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className={`font-heading text-xl md:text-2xl font-bold tracking-tight whitespace-nowrap ${isScrolled ? 'text-primary-500' : 'text-white'}`}>
              炮渣漫画
            </span>
            <span className={`w-2 h-2 rounded-full mt-1 ${isScrolled ? 'bg-primary-500' : 'bg-accent-500'}`}></span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.to
                    ? isScrolled ? 'text-primary-500' : 'text-white font-semibold'
                    : isScrolled ? 'text-foreground-600 hover:text-primary-500' : 'text-white/80 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                isScrolled ? 'text-foreground-600 hover:text-primary-500' : 'text-white/70 hover:text-white'
              }`}
            >
              关于我们
            </Link>
            <button
              type="button"
              className={`text-sm font-medium px-5 py-2 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm'
              }`}
            >
              登录
            </button>
          </div>

          <button
            type="button"
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${isScrolled ? 'text-foreground-800' : 'text-white'}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-6 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-foreground-700 hover:text-primary-500 text-sm font-medium py-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <hr className="border-background-200/70" />
            <Link
              to="/about"
              className="text-foreground-700 hover:text-primary-500 text-sm font-medium py-2"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              关于我们
            </Link>
            <button
              type="button"
              className="bg-primary-500 text-white text-sm font-medium px-5 py-2 rounded-full whitespace-nowrap cursor-pointer w-fit"
            >
              登录
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}